import { render, staticRenderFns } from "./goodResults.vue?vue&type=template&id=a0a5728a&scoped=true&"
import script from "./goodResults.vue?vue&type=script&lang=js&"
export * from "./goodResults.vue?vue&type=script&lang=js&"
import style0 from "./goodResults.vue?vue&type=style&index=0&id=a0a5728a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a5728a",
  null
  
)

export default component.exports